import React from 'react';
import { Tabs,Tab } from 'react-bootstrap';

export const TabList = ({tabList,tabClass="",defaultActiveKey,badge,badgeClass=""}) => {
    return (
        <Tabs  defaultActiveKey={defaultActiveKey} id="uncontrolled-tab-example" className={tabClass}>
        {tabList.map(item=><Tab eventKey={item.key}
          title={
            <React.Fragment>
              {item.label}
              {badge && item.count>0 && <span className={badgeClass}>{item.count}</span>}
            </React.Fragment>
          }
        >{item.content}</Tab> )}
    </Tabs>
    );
}

